import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, DeferLoadingStrategy } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { LoginFooterComponent } from './login-footer.component';

@NgModule({
  declarations: [LoginFooterComponent],
  imports: [
    CommonModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ShimanoLoginFooterComponent: {
          component: LoginFooterComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
  ],
})
export class LoginFooterModule {}
